import { useState } from 'react';
import { useAuth } from '../AuthContext';
import styles from './VerifyEmailBanner.module.css';

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified) return null;

  async function resend() {
    setSending(true);
    try {
      const res = await fetch('/api/auth/verify-email/request', {
        method: 'POST',
        credentials: 'include',
      });
      if (res.ok) setSent(true);
    } finally {
      setSending(false);
    }
  }

  return (
    <div className={styles.banner}>
      <span>
        이메일 인증이 필요합니다. <b>{user.email}</b>로 보낸 메일을 확인해주세요.
      </span>
      {sent ? (
        <span className={styles.sent}>전송됨 ✓</span>
      ) : (
        <button className={styles.resend} onClick={resend} disabled={sending}>
          {sending ? '발송 중...' : '메일 다시 보내기'}
        </button>
      )}
    </div>
  );
}
